import type { User } from '@models/auth/user';
import { type Reactive, reactive, ref } from 'vue';
import { defineStore } from 'pinia';

export const useContactFormStore = defineStore('contactForm', () => {
  const firstname = ref('');
  const lastname = ref('');
  const email = ref('');
  const phoneNumber = ref('');
  const message = ref('');

  interface contactFormData {
    firstname: string,
    lastname: string,
    email: string,
    phoneNumber: string,
    message: string,
  }

  const getData = (): Reactive<contactFormData> => (
    reactive({
      firstname,
      lastname,
      email,
      phoneNumber,
      message,
    }));

  const persist = (): void => {
    localStorage.setItem(
      'contactForm',
      JSON.stringify({
        firstname: firstname.value,
        lastname: lastname.value,
        email: email.value,
        phoneNumber: phoneNumber.value,
        message: message.value,
      }),
    );
  };

  const load = (user: User | null) => {
    const saved = JSON.parse(localStorage.getItem('contactForm') ?? '{}');

    firstname.value = saved.firstname ?? '';
    lastname.value = saved.lastname ?? '';
    email.value = saved.email ?? '';
    phoneNumber.value = saved.phoneNumber ?? '';
    message.value = saved.message ?? '';

    if (user) {
      firstname.value = user.firstname;
      lastname.value = user.lastname;
      email.value = user.email;
      phoneNumber.value = user.phone_number ?? '';
    }

    const { lastUserMessage } = window.offerContactInitialAppState ?? {};
    if (lastUserMessage) {
      message.value = lastUserMessage;
      persist();
    }
  };

  return {
    firstname,
    lastname,
    email,
    phoneNumber,
    message,
    load,
    persist,
    getData,
  };
});
